/* eslint-disable no-lone-blocks */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import {
  Typography,
  Box,
  IconButton,
  useTheme,
  Link,
  Breadcrumbs,
  Button,
  TextField,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import "moment/locale/pt";
import MUIDataTable from "mui-datatables";
import Instance from "../../../../utils/Axios";
import BASE_URL from "../../../../utils/BASE_URL";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptLocale from "date-fns/locale/pt";

// Components
import FooterLinks from "../../../../Global/Components/Footer";

//Icons
import FeatherIcon from "feather-icons-react";
import GetAllAdesoes from "../../../../utils/redux/actions/plus/GetAllAdesoes";
import { format } from "date-fns";
import GetAdesaoById from "../../../../utils/redux/actions/plus/GetAdesaoById";
import GetPlusTipoTarifas from "../../../../utils/redux/actions/plus/GetPlusTipoTarifasAction";
import GetPlusCiclos from "../../../../utils/redux/actions/plus/GetPlusCiclosAction";
import GetPlusEscaloes from "../../../../utils/redux/actions/plus/GetPlusEscaloesAction";
import GetPlusPotencias from "../../../../utils/redux/actions/plus/GetPlusPotenciasAction";
import GetPlusPlanos from "../../../../utils/redux/actions/plus/GetPlusPlanosAction";
import fileDownload from "js-file-download";
import GetPlusStatus from "../../../../utils/redux/actions/plus/GetPlusStatusAction";
import GetPlusServices from "../../../../utils/redux/actions/plus/GetPlusServicesAction";
import GetAdesaoFilesById from "../../../../utils/redux/actions/plus/GetAdesaoFilesAdesaoById";
import GetAdesaoFilesCompExcById from "../../../../utils/redux/actions/plus/GetAdesaoFilesCompExcById";
import GetAdesaoFilesAdesaoById from "../../../../utils/redux/actions/plus/GetAdesaoFilesAdesaoById";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import GetPlusTipoEdificios from "../../../../utils/redux/actions/plus/GetPlusTipoEdificiosActions";
import GetPlusTipoDonos from "../../../../utils/redux/actions/plus/GetPlusTipoDonosAction";
import GetPlusTipoDocs from "../../../../utils/redux/actions/plus/GetPlusTipoDocsAction";
import ModalDelete from "./components/modalDelete";
import GetAdesaoHistoricoById from "../../../../utils/redux/actions/plus/GetAdesaoHistoricoById";
import GetAllClients from "../../../../utils/redux/actions/plus/GetAllClientsAction";
import SideDrawerClientes from "./components/drawer";
import ModalDeleteCliente from "./components/modalDelete";
import GetClientById from "../../../../utils/redux/actions/plus/GetClientByIdAction";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      // margin: theme.spacing(1),
      width: "25ch",
    },
  },
  btnFiltrar: {
    color: "#E21450",
    width: "150px",
    height: "40px",
    fontWeight: "900",
    // borderRadius: '15px',
    backgroundColor: "white",
    border: `1px solid #707070`,
    display: "flex",
    alignItems: "center",
    transition: "0.2s",
    "&:hover": {
      backgroundColor: "#ECECEC",
      border: "1px solid #707070",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "#F7F7F7 ",
      },
    },
  },
  stateLabel: {
    textTransform: "none",
    transition: "0.2s",
    display: "flex",
    alignItems: "center",
  },

  paperFilters: {
    background: "transparent",
    padding: "20px 0px",
    boxShadow: "none",
  },
  button: {
    display: "flex",
    justifyContent: "center",
    height: 40,
    borderTop: "4px solid transparent",
    borderBottom: "4px solid transparent",

    "&:hover": {
      borderRight: "4px solid #E21450",
    },
  },
}));

const ColorStateCube = ({ color }) => {
  return (
    <div
      style={{
        height: "10px",
        width: "10px",
        backgroundColor: color,
        marginRight: "10px",
        borderRadius: "3px",
      }}
    />
  );
};

// ############################################################## //
// ####################  Window Dimensions  ##################### //
// ############################################################## //

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const PlusClientes = () => {
  const location = useLocation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [responsive] = useState("standard");
  const [tableBodyHeight] = useState("100%");
  const [tableBodyMaxHeight] = useState("");

  const user = useSelector((state) => state.user);

  const clientesState = useSelector((state) => state.plus.clientes);

  const tiposTarifas = useSelector((state) => state.plus.tipoTarifas);
  const ciclos = useSelector((state) => state.plus.ciclos);
  const escaloes = useSelector((state) => state.plus.escaloes);
  const potencias = useSelector((state) => state.plus.potencias);
  const planos = useSelector((state) => state.plus.planos);
  const status = useSelector((state) => state.plus.status);
  const tiposDonos = useSelector((state) => state.plus.tipoDonos);
  const tiposEdificios = useSelector((state) => state.plus.tipoEdificios);
  const tiposDocs = useSelector((state) => state.plus.tipoDocs);

  const servicos = useSelector((state) => state.plus.services);

  const [servico, setServico] = useState({ id: null, name: "" });
  const [estado, setEstado] = useState({ id: null, name: "" });
  const [date, setDate] = useState(null);

  const filteredStatus = status.filter((s) => s.servId == servico.id);

  // ############################################################## //
  // ###########################  Modal  ########################## //
  // ############################################################## //
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clienteId, setClienteId] = useState(null);

  const handleOpen = (e, id) => {
    e.preventDefault();

    setLoading(false);

    setOpenDelete(true);
    setClienteId(id);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpenDelete(false);
  };

  const handleDate = (date) => {
    setDate(date);
  };

  const fetchClientes = () => {
    dispatch(GetAllClients());
  };

  const fetchClientById = (id) => {
    dispatch(GetClientById(id));
  };

  const fetchTipoDocs = () => {
    dispatch(GetPlusTipoDocs());
  };

  useEffect(() => {
    fetchTipoDocs();
    fetchClientes();
  }, []);

  const [cliente, setCliente] = useState({
    nome: "",
    telemovel: "",
    telefone: "",
    email: "",
    nif: "",
    numero_documento: "",
    certidao_permanente: "",
    iban: "",
    swift: "",
    morada: "",
    cod_postal: "",
    localidade: "",
    concelho: "",
    distrito: "",
    data: "",
    nipc: "",
    cae: "",
    nome_empresa: "",
    rep_legal: "",
  });

  const resetCliente = () => {
    setCliente({
      id: "",
      nome: "",
      telemovel: "",
      telefone: "",
      email: "",
      nif: "",
      numero_documento: "",
      certidao_permanente: "",
      iban: "",
      swift: "",
      morada: "",
      cod_postal: "",
      localidade: "",
      concelho: "",
      distrito: "",
      data: "",
      nipc: "",
      cae: "",
      nome_empresa: "",
      rep_legal: "",
    });
  };

  // ############################################################## //
  // ########################  Drawer  ############################ //
  // ############################################################## //

  const [drawerWidth, setDrawerWidth] = useState("90vw");
  const dimensions = useWindowDimensions();
  const [state, setState] = useState({
    right: false,
  });
  const [drawerState, setDrawerState] = useState(null);
  const toggleDrawer = (anchor, open, id) => {
    console.log(id);
    if (open == false) {
      setState({ ...state, [anchor]: open });
      // setCredenciacaoId(null);
      resetCliente();
    }
    if (open == true) {
      setState({ ...state, [anchor]: open });
      // setCredenciacaoId(id);
      fetchClientById(id);
    }
  };

  // ############################################################## //
  // ##################  MUI Datatable columns  ################### //
  // ############################################################## //

  const renderTarifa = (value) => {
    switch (value) {
      case "simples":
        return "Simples";
      case "bi_horario":
        return "Bi-Horário";
      case "tri_horario":
        return "Tri-Horário";
      default:
        break;
    }
  };

  const renderEscalao = (value) => {
    switch (value) {
      case "escalao1":
        return "Escalão 1";
      case "escalao2":
        return "Escalão 2";
      case "escalao3":
        return "Escalão 3";
      default:
        break;
    }
  };

  const columns = [
    {
      name: "id_jaf_plus_client_profile",
      label: "",
      options: {
        display: false,
      },
    },
    {
      name: "jaf_plus_client_profile_name",
      label: "Nome",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          // const apelido = tableMeta.rowData[3];
          const empresa = tableMeta.rowData[2];
          return (
            <div className="table-btns-tiposatrasos">
              {value ? (
                <Typography>{value}</Typography>
              ) : (
                <Typography>{empresa}</Typography>
              )}
            </div>
          );
        },
      },
    },
    // {
    //   name: "jaf_plus_client_form_data_last_name",
    //   label: "Apelido",
    //   options: {
    //     display: false,
    //   },
    // },
    {
      name: "jaf_plus_client_profile_company_name",
      label: "Nome de empresa",
      options: {
        display: false,
      },
    },
    {
      name: "jaf_plus_client_profile_contact_mobile",
      label: "Telemóvel",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "jaf_plus_client_profile_cc",
      label: "CC",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "jaf_plus_client_profile_email",
      label: "Email",
      options: {
        filter: true,
        sort: true,
      },
    },
    // },
    // {
    //   name: "jaf_plus_client_form_data_cpe",
    //   label: "CPE",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta) => {
    //       return (
    //         <div className="table-btns-tiposatrasos">
    //           {value == null ? (
    //             <Typography>N/D</Typography>
    //           ) : (
    //             <Typography>{value}</Typography>
    //           )}
    //         </div>
    //       );
    //     },
    //   },
    // },
    // {
    //   name: "jaf_plus_client_form_data_cui",
    //   label: "CUI",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta) => {
    //       return (
    //         <div className="table-btns-tiposatrasos">
    //           {value == null ? (
    //             <Typography>N/D</Typography>
    //           ) : (
    //             <Typography>{value}</Typography>
    //           )}
    //         </div>
    //       );
    //     },
    //   },
    // },
    // {
    //   name: "id_jaf_plus_tariff_plan",
    //   label: "Tipo de Contrato",

    // },

    // {
    //   name: "power",
    //   label: "Potência",
    //   options: {
    //     filter: true,
    //     sort: true,
    //   },
    // },
    // {
    //   name: "cycle",
    //   label: "Ciclo",
    //   options: {
    //     filter: true,
    //     sort: true,
    //   },
    // },
    // {
    //   name: "level",
    //   label: "Escalão",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta) => {
    //       return (
    //         <div className="table-btns-tiposatrasos">
    //           <Typography>{renderEscalao(value)}</Typography>
    //         </div>
    //       );
    //     },
    //   },
    // },
    {
      name: "jaf_plus_client_profile_created_at",
      label: "Data",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <div className="table-btns-tiposatrasos">
              {value == null ? (
                " - "
              ) : (
                <>{format(new Date(value), "dd/MM/yyyy")}</>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellProps: () => ({
          style: { width: "5%" },
          align: "center",
          margin: 0,
          padding: 0,
        }),
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <div style={{ display: "flex", float: "right" }}>
              {(user.permissoes.includes("APP_JAFPLUS_EDITAR_CLIENTES") ||
                user.permissoes.includes("APP_JAFPLUS_CONSULTAR_CLIENTES")) && (
                <IconButton
                  onClick={() => {
                    setDrawerState("watch");
                    toggleDrawer("right", true, id);
                  }}
                  style={{
                    padding: 6,
                    color: theme.palette.secondary.main,
                  }}
                >
                  <FeatherIcon
                    icon="eye"
                    size={20}
                    style={{ strokeWidth: "1.5" }}
                  />
                </IconButton>
              )}
              {user.permissoes.includes("APP_JAFPLUS_APAGAR_CLIENTES") && (
                <IconButton
                  onClick={(e) => {
                    handleOpen(e, id);
                  }}
                  style={{
                    padding: 6,
                    color: theme.palette.secondary.main,
                  }}
                >
                  <FeatherIcon
                    icon="trash-2"
                    size={20}
                    style={{ strokeWidth: "1.5" }}
                  />
                </IconButton>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "contratoFileId",
      label: "contratoFileId",
      options: {
        display: false,
      },
    },
    {
      name: "contrato",
      label: "contrato",
      options: {
        display: false,
      },
    },
    {
      name: "jaf_plus_client_form_data_emited_flag",
      label: "emitir_flag",
      options: {
        display: false,
      },
    },
  ];

  // ############################################################## //
  // ##################  MUI Datatable Options  ################### //
  // ############################################################## //

  const searchText =
    location.state && location.state.funcionarioNome
      ? location.state.funcionarioNome
      : null;

  const options = {
    filter: false,
    filterType: "dropdown",
    responsive,
    searchText: searchText,
    tableBodyHeight,
    tableBodyMaxHeight,
    selectableRows: "none",
    viewColumns: false,
    elevation: 5,
    pagination: true,
    print: false,
    download: false,
    rowsPerPage: 100,
    rowsPerPageOptions: [100, 150, 200, 250, 300],
    textLabels: {
      body: {
        noMatch: "Sem Registos encontrados",
        // toolTip: 'Dia',
        columnHeaderTooltip: (column) => `${column.label}`,
      },
      toolbar: {
        search: "Pesquisar",
      },
      pagination: {
        next: "Proxima Página",
        previous: "Página Anterior",
        rowsPerPage: "Mostrar:",
        displayRows: "de",
      },
    },
    customToolbar: () => {
      return (
        <>
          {user.permissoes.includes("APP_JAFPLUS_CRIAR_CLIENTES") && (
            <Tooltip title={"Adicionar Contrato"}>
              <IconButton
                className={classes.iconButton}
                onClick={() => {
                  setDrawerState("add");
                  toggleDrawer("right", true, null);
                }}
              >
                <FeatherIcon
                  icon="plus-square"
                  size={22}
                  className={classes.deleteIcon}
                  style={{ strokeWidth: "2" }}
                />
              </IconButton>
            </Tooltip>
          )}
        </>
      );
    },
  };

  //   const handleSubmit = () => {
  //     const serviceId = servico.id;
  //     const statusId = estado.id;

  //     fetchAdesoes(serviceId, statusId, date);
  //   };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mr: 10,
          width: "100%",
        }}
      >
        <SideDrawerClientes
          state={state}
          toggleDrawer={toggleDrawer}
          drawerState={drawerState}
          drawerWidth={drawerWidth}
          dimensions={dimensions}
          fetchClientes={fetchClientes}
          cliente={cliente}
          setCliente={setCliente}
          tiposDocs={tiposDocs}
          servico={servico}
        />
        <ModalDeleteCliente
          openDelete={openDelete}
          handleClose={handleClose}
          clienteId={clienteId}
          fetchClientes={fetchClientes}
          // Loading
          loading={loading}
          setLoading={setLoading}
        />
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              mx: 5,
              mt: 5,
              width: "100%",
            }}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/construcoes/obras">
                Gestão Comercial
              </Link>
              <Typography color="text.primary">Clientes</Typography>
            </Breadcrumbs>
            {/* <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ width: "240px" }}>
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Tipo de contrato
                  </Typography>
                  <Autocomplete
                    fullWidth
                    name="nome"
                    clearText="Limpar"
                    openText="Abrir"
                    closeText="Fechar"
                    noOptionsText="Sem dados"
                    value={servico}
                    className="unidadesId-form"
                    options={servicos || []}
                    getOptionLabel={(option) => `${option.name}` || ""}
                    isOptionEqualToValue={(option, value) => {
                      // if (!value.id) return true;
                      return value.id === option.id;
                    }}
                    style={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" variant="outlined" />
                    )}
                    onChange={(_, value, reason) => {
                      if (reason == "clear") {
                        setServico({ id: null, name: "" });
                      } else {
                        setServico(value);
                      }
                      return value;
                    }}
                  />
                </Box>
                <Box sx={{ width: "240px", mx: 4 }}>
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Estado
                  </Typography>
                  <Autocomplete
                    fullWidth
                    name="nome"
                    clearText="Limpar"
                    openText="Abrir"
                    closeText="Fechar"
                    noOptionsText="Sem dados"
                    value={estado}
                    className="unidadesId-form"
                    options={filteredStatus}
                    getOptionLabel={(option) => `${option.name}` || ""}
                    isOptionEqualToValue={(option, value) => {
                      // if (!value.id) return true;
                      return value.id === option.id;
                    }}
                    style={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" variant="outlined" />
                    )}
                    onChange={(_, value, reason) => {
                      if (reason == "clear") {
                        setEstado({ id: null, name: "" });
                      } else {
                        setEstado(value);
                      }
                      return value;
                    }}
                  />
                </Box>
                <Box sx={{ width: "240px" }}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={ptLocale}
                  >
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Data
                    </Typography>
                    <Box sx={{ display: "flex" }}>
                      <DatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        format="dd/MM/yyyy"
                        okLabel="ok"
                        cancelLabel="cancelar"
                        invalidDateMessage="Data Inválida"
                        value={date}
                        onChange={handleDate}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              placeholder: "dd/mm/aaaa",
                            }}
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                            }}
                            sx={{ width: "200px" }}
                            variant="outlined"
                            size="small"
                          />
                        )}
                      />
                    </Box>
                  </LocalizationProvider>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignSelf: "end",
                }}
              >
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  className={classes.btnFiltrar}
                >
                  Filtrar
                </Button>
              </Box>
            </Box> */}
          </Box>

          <div
            style={{
              margin: "0px 40px 40px 40px",
              width: "100%",
            }}
          >
            <MUIDataTable
              title={
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                  className="text-underline"
                >
                  Clientes
                </span>
              }
              data={clientesState || []}
              columns={columns}
              options={options}
            />
          </div>
          <div style={{ margin: "20px 40px" }}>
            <FooterLinks />
          </div>
        </Box>
      </Box>
    </>
  );
};

export default PlusClientes;
